import React from 'react'
import './style.css'

export default class Login extends React.Component{

    state = {
        usuario : '',
        senha : ''
    }

    handlers = {
        usuario : (e) => this.setState({usuario: e.target.value}),
        senha : (e) => this.setState({senha:e.target.value}),
        login : () => {
            if(this.state.usuario.length<3 || this.state.senha.length<3) this.props.feedback('Favor, preencher usuário e senha')
            else this.props.login(this.state.usuario, this.state.senha)
        },
        cancelar : () =>{
            this.props.history.push('/')
        }
    }

    render(){
        let {handlers} = this;

        console.log('loginjs component props', this.props)

        if(this.props.algoCerto) {
            this.props.feedback('Parabéns, você foi logado com sucesso')
            this.props.history.push('/adm')
        }

        return(
            <div className='login_container'>
                <div className='inner_container'>
                    <h3>Login para área administrativa</h3>
                    <label>
                        Usuário <input type="text" onChange={handlers.usuario} placeholder='Usuário' onKeyUp={e=>e.keyCode===13?handlers.login():null} />
                    </label>
                    <label>
                        Senha <input type="password" onChange={handlers.senha} placeholder='Senha' onKeyUp={e=>e.keyCode===13?handlers.login():null} />
                    </label>

                    {this.props.algoErrado? <span className='algo_errado'>Desculpe, mas usuário e senha não batem</span> : <div/>}

                    <div className='acoes'>
                        <div className='login' onClick={handlers.login}>
                            Continuar
                        </div>
                        <div className='cancelar' onClick={handlers.cancelar}>
                            Cancelar
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/views/login/component.js